import { useGameStore } from '@/store/gameStore'
import { slotDark, slotRed } from '@/assets/ui/panels'
import { regularRolls } from '@/assets/rolls'
import { fromMinor } from '@/utils/money'

interface HistoryPanelProps {
  onClose?: () => void
}

// Стиль шрифта как в BetPanel
const fontStyle: React.CSSProperties = {
  fontFamily: "'Big Shoulders Display', sans-serif",
  fontWeight: 800,
  lineHeight: '100%',
  textAlign: 'center',
}

export default function HistoryPanel({ onClose: _onClose }: HistoryPanelProps) {
  const { gameHistory } = useGameStore()

  // Высота контента = 48 + 8 + 40 + 8 + 40 = 144px (как в BetPanel)
  // Карточка: верх 68px + ставка 34px + gap 4px + выигрыш 34px + gap 4px = 144px
  
  return (
    <div 
      className="relative w-full"
      style={{
        background: '#F8DDCA',
        borderRadius: '3px',
        padding: '3px',
      }}
    >
      {/* Горизонтальный скролл с карточками */}
      <div 
        className="flex gap-3 overflow-x-auto custom-scrollbar"
        style={{ height: '118px' }}
      >
        {gameHistory.length === 0 ? (
          // Пустая история — показываем сообщение
          <div className="flex-1 flex items-center justify-center">
            <span style={{ ...fontStyle, fontSize: '18px', color: '#F8DDCA', opacity: 0.5 }}>
              No games yet
            </span>
          </div>
        ) : (
          gameHistory.slice(0, 20).map((entry, index) => {
            const isWin = entry.status === 'win' && entry.result > 0
            const rollIcon = regularRolls[index % regularRolls.length]
            // КРАСНЫЙ = выигрыш, ТЁМНЫЙ = проигрыш
            const slotBg = isWin ? slotRed : slotDark
            
            return (
              <div 
                key={entry.gameId}
                className="flex-shrink-0 w-[90px] h-full overflow-hidden flex flex-col"
                style={{
                  backgroundImage: `url(${slotBg})`,
                  backgroundSize: '100% 100%',
                }}
              >
                {/* Верхняя часть — ролл и множитель */}
                <div className="flex-1 flex items-center justify-center gap-2 px-2">
                  <img 
                    src={rollIcon.src} 
                    alt="" 
                    className="w-8 h-8 object-contain"
                  />
                  <div className="text-right">
                    <span style={{ ...fontStyle, fontSize: '16px', color: '#F8DDCA' }}>
                      x{entry.rollsCount}
                    </span>
                    <br />
                    <span style={{ ...fontStyle, fontSize: '12px', color: '#F8DDCA' }}>
                      x{entry.maxCoefficient.toFixed(1)}
                    </span>
                  </div>
                </div>
                
                {/* Ставка — светлый блок */}
                <div className="h-[34px] bg-[#F8DDCA] flex items-center justify-center mx-1">
                  <span style={{ ...fontStyle, fontSize: '18px', color: '#243043' }}>
                    {fromMinor(entry.bet)}
                  </span>
                </div>
                
                {/* Выигрыш — светлый блок */}
                <div 
                  className="h-[34px] flex items-center justify-center mx-1 mt-1 mb-1"
                  style={{ backgroundColor: '#E8CDB8' }}
                >
                  <span style={{ ...fontStyle, fontSize: '18px', color: isWin ? '#065F46' : '#243043' }}>
                    {fromMinor(entry.result)}
                  </span>
                </div>
              </div>
            )
          })
        )}
      </div>
      
      {/* Кастомная полоска скролла */}
      <style>{`
        .custom-scrollbar::-webkit-scrollbar {
          height: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #243043;
          border-radius: 3px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #DC2626;
          border-radius: 3px;
          min-width: 40px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #EF4444;
        }
      `}</style>
    </div>
  )
}

